// Header Logo
$(document).ready(function () {
  function initLogoHover($header) {
    if ($header.data('hover-initialized')) return;
    $header.data('hover-initialized', true);

    const $link = $header.find('a').first();
    if (!$link.length) return;

    const hoverUrls = [];
    let i = 1;
    while (true) {
      const url = $header.attr('data-logo-hover-' + i);
      if (url && $.trim(url) !== '') {
        hoverUrls.push($.trim(url));
        i++;
      } else {
        break;
      }
    }
    if (hoverUrls.length === 0) return;

    const $imgs = $link.find('img');

    // store originals
    $imgs.each(function () {
      const $img = $(this);
      if ($img.data('original-src') === undefined) {
        $img.data('original-src', $img.attr('src') || '');
        $img.data('original-srcset', $img.attr('srcset') || '');
      }
    });

    let lastIndex = -1;

    function applyHover(url) {
      $imgs.each(function () {
        $(this).attr('src', url);
        if ($(this).is('[srcset]')) $(this).attr('srcset', url);
      });
    }

    function restoreOriginals() {
      $imgs.each(function () {
        const $img = $(this);
        $img.attr('src', $img.data('original-src') || '');
        if ($img.data('original-srcset') !== undefined) {
          $img.attr('srcset', $img.data('original-srcset') || '');
        } else {
          $img.removeAttr('srcset');
        }
      });
    }

    $link.on('mouseenter.logoHover', function () {
      lastIndex = (lastIndex + 1) % hoverUrls.length;
      applyHover(hoverUrls[lastIndex]);
    });

    $link.on('mouseleave.logoHover', function () {
      restoreOriginals();
    });

    // Basic touch support for mobile: show hover on tap and restore shortly after release
    $link.on('touchstart.logoHover', function () {
      lastIndex = (lastIndex + 1) % hoverUrls.length;
      applyHover(hoverUrls[lastIndex]);
    });
    $link.on('touchend.logoHover touchcancel.logoHover', function () {
      // small delay so user can see the change
      setTimeout(restoreOriginals, 200);
    });
  }

  // init existing headers
  $('.bl-header__logo_hover-change').each(function () {
    initLogoHover($(this));
  });

  // Re-init when Shopify sections are loaded (editor)
  $(document).on('shopify:section:load', function (event) {
    $(event.target).find('.bl-header__logo_hover-change').each(function () {
      initLogoHover($(this));
    });
  });
});



// Marquee Images (BL)
// Marquee Texts (BL)
class BoollandMarquee extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
    }
  }

  connectedCallback() {
    if (this.getAttribute("pause-when-hover") === "true") {
      this.addEventListener("mouseenter", () => {
        this.querySelectorAll(".bl-marquee__content").forEach(el => {
          el.style.animationPlayState = "paused";
        });
      });

      this.addEventListener("mouseleave", () => {
        this.querySelectorAll(".bl-marquee__content").forEach(el => {
          el.style.animationPlayState = "running";
        });
      });
    }
  }

  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5);
    const contentWidth = entries[0].contentRect.width;
    const span = entries[0].target.querySelector("span");
    if (!span) return;

    const slowFactor =
      1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);

    const duration = (
      (scrollingSpeed * slowFactor * span.clientWidth) /
      contentWidth
    ).toFixed(3);

    this.style.setProperty("--marquee-animation-duration", `${duration}s`);
  }
};

if (!window.customElements.get("boolland-marquee")) {
  window.customElements.define("boolland-marquee", BoollandMarquee);
}

// Testimonials (BL)
class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const section = this.querySelector(".bl_testimonials");
    const cards = section.querySelectorAll(".bl_testimonials__card");
    const dots = this.querySelectorAll(".bl_testimonials__controls .bl_testimonials__dots");

    const isVisible = el => {
      return el.offsetParent !== null; // element is in layout (not display:none)
    };

    // Handle clicks on dots
    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        const id = dot.dataset.id;

        // Remove previous active
        dots.forEach(d => d.classList.remove("active"));
        dot.classList.add("active");

        // Find the visible card with same data-id
        const target = Array.from(cards).find(
          c => c.dataset.id === id && isVisible(c)
        );

        if (target) {
          section.scrollTo({
            left: target.offsetLeft,
            behavior: "smooth"
          });
        }
      });
    });

    // Handle scroll sync
    section.addEventListener("scroll", () => {
      let closest = null;
      let minDist = Infinity;

      Array.from(cards)
        .filter(isVisible)
        .forEach(card => {
          const dist = Math.abs(card.offsetLeft - section.scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = card;
          }
        });

      if (closest) {
        const id = closest.dataset.id;

        dots.forEach(d => {
          if (d.dataset.id === id) {
            d.classList.add("active");
          } else {
            d.classList.remove("active");
          }
        });
      }
    });
  }
}

if (!window.customElements.get("testimonials-slider")) {
  window.customElements.define("testimonials-slider", TestimonialsSlider);
}

// Main Series (BL) - Visual Slider
class VisualSliders extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0; 
    this.prevTranslate = 0;
    this.pointerId = null;
    this.slideWidth = 0;
    this.track = null;
    this.slides = [];
    this.indicators = [];
    this.descriptions = [];
    this.onResize = this.updateDimensions.bind(this);
  }

  connectedCallback() {
    this.track = this.querySelector(".main_series__visual_slide__track");
    this.slides = Array.from(this.querySelectorAll(".main_series__visual"));
    this.indicators = Array.from(
      document.querySelectorAll(`[for='${this.id}'] .visual_indicator`)
    );
    this.descriptions = Array.from(
      document.querySelectorAll(`[for='${this.id}'] .main_series__description`)
    );

    if (!this.track || this.slides.length === 0) return;

    this.updateDimensions();
    window.addEventListener("resize", this.onResize);

    // Check if URL has ?visual=handle
    const params = new URLSearchParams(window.location.search);
    const visualHandle = params.get("visual");

    let targetIndex = 0;
    if (visualHandle) {
      const foundIndex = this.slides.findIndex(
        slide => slide.dataset.handle === visualHandle
      );
      if (foundIndex >= 0) {
        targetIndex = foundIndex;
      }
    }

    // Always start at first slide instantly (no animation)
    this.goToSlide(0, false);

    // If target is not the first, animate to it after small delay
    if (targetIndex > 0) {
      setTimeout(() => {
        this.goToSlide(targetIndex, true);
      }, 300); // you can tweak 300ms delay
    }

    // Indicators click
    this.indicators.forEach((indicator, idx) => {
      indicator.addEventListener("click", () => this.goToSlide(idx));
    });

    // Drag handling
    this.slides.forEach((slide, idx) => {
      slide.querySelectorAll("img, video").forEach(el =>
        el.addEventListener("dragstart", e => e.preventDefault())
      );

      slide.addEventListener("pointerdown", e => this.onPointerDown(e, idx));
      slide.addEventListener("pointermove", e => this.onPointerMove(e));
      slide.addEventListener("pointerup", e => this.onPointerUp(e));
      slide.addEventListener("pointercancel", e => this.onPointerUp(e));
    });
  }


  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }

  updateDimensions() {
    this.slideWidth = this.clientWidth || this.getBoundingClientRect().width || 1;
  }

  applyTranslate(percent, withTransition = false, distance = 1) {
    this.slides.forEach((s) => {
      const duration = withTransition ? 0.3 * distance : 0;
      s.style.transition = withTransition ? `transform ${duration}s ease` : "none";
      s.style.transform = `translateX(${percent}%)`;
    });
  }


  updateIndicators() {
    this.indicators.forEach((el, i) =>
      el.classList.toggle("active", i === this.currentIndex)
    );
  }

  updateDescriptions() {
    this.descriptions.forEach((el, i) =>
      el.classList.toggle("active", i === this.currentIndex)
    );
  }

  // 👉 goToSlide now updates ?visual=<handle>
  goToSlide(index, animate = true) {
    index = Math.max(0, Math.min(index, this.slides.length - 1));
    const distance = Math.abs(index - this.currentIndex) || 1; // at least 1
    this.currentIndex = index;
    this.prevTranslate = -index * 100;
    this.currentTranslate = this.prevTranslate;

    this.applyTranslate(this.prevTranslate, animate, distance);
    this.updateIndicators();
    this.updateDescriptions();

    // Update URL with visual handle
    const handle = this.slides[this.currentIndex].dataset.handle;
    if (handle) {
      const url = new URL(window.location.href);
      url.searchParams.set("visual", handle);
      window.history.replaceState({}, "", url);
    }
  }


  onPointerDown(e, index) {
    if (e.button && e.button !== 0) return;

    this.isDragging = true;
    this.pointerId = e.pointerId;
    this.startX = e.clientX;
    this.prevTranslate = -this.currentIndex * 100;
    this.currentTranslate = this.prevTranslate;

    this.applyTranslate(this.currentTranslate, false);

    this.slides.forEach(s => s.style.cursor = "grabbing");

    try {
      e.currentTarget.setPointerCapture(this.pointerId);
    } catch (err) {
      // ignore
    }

    e.preventDefault();
  }

  onPointerMove(e) {
    if (!this.isDragging || e.pointerId !== this.pointerId) return;

    const deltaX = e.clientX - this.startX;
    const deltaPercent = (deltaX / this.slideWidth) * 100;
    this.currentTranslate = this.prevTranslate + deltaPercent;

    this.applyTranslate(this.currentTranslate, false);

    e.preventDefault();
  }

  onPointerUp(e) {
    if (!this.isDragging || (this.pointerId && e.pointerId !== this.pointerId)) return;

    try {
      e.currentTarget.releasePointerCapture(this.pointerId);
    } catch (err) {
      // ignore
    }

    this.slides.forEach(s => s.style.cursor = "grab");

    this.isDragging = false;
    this.pointerId = null;

    const movedPercent = this.currentTranslate - this.prevTranslate;

    if (movedPercent <= -10 && this.currentIndex < this.slides.length - 1) {
      this.currentIndex += 1;
    } else if (movedPercent >= 10 && this.currentIndex > 0) {
      this.currentIndex -= 1;
    }
    this.goToSlide(this.currentIndex, true);
  }
}

if (!window.customElements.get("visual-sliders")) {
  window.customElements.define("visual-sliders", VisualSliders);
}

class BoollandVerticalMarquee extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
    }
  }

  connectedCallback() {
    if (this.getAttribute("pause-when-hover") === "true") {
      this.addEventListener("mouseenter", () => {
        this.querySelectorAll(".bl-vmarquee__content").forEach(el => {
          el.style.animationPlayState = "paused";
        });
      });

      this.addEventListener("mouseleave", () => {
        this.querySelectorAll(".bl-vmarquee__content").forEach(el => {
          el.style.animationPlayState = "running";
        });
      });
    }
  }

  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5);
    const contentHeight = entries[0].contentRect.height;
    const span = entries[0].target.querySelector("span");
    if (!span) return;

    const slowFactor =
      1 + (Math.min(1600, contentHeight) - 375) / (1600 - 375);

    const duration = (
      (scrollingSpeed * slowFactor * span.clientHeight) /
      contentHeight
    ).toFixed(3);

    this.style.setProperty("--vmarquee-animation-duration", `${duration}s`);
  }
};

if (!window.customElements.get("boolland-vmarquee")) {
  window.customElements.define("boolland-vmarquee", BoollandVerticalMarquee);
}
